// Lookup hooks feeding the funds grid + הגדרת קרן form FK dropdowns.
import { createLookupHook } from './createLookupHook';
import { getFundClassifications } from '../api/fundClassifications';
import { getIsaFundClassifications } from '../api/isaFundClassifications';
import { getProspectusExposureTypes } from '../api/prospectusExposureTypes';
import { getOperators } from '../api/operators';
import { getTrustees } from '../api/trustees';
import { getCompanies } from '../api/companies';
import type { FundClassification } from '../types/FundClassification';
import type { IsaFundClassification } from '../types/IsaFundClassification';
import type { ProspectusExposureType } from '../types/ProspectusExposureType';
import type { Operator } from '../types/Operator';
import type { Trustee } from '../types/Trustee';
import type { Company } from '../types/Company';

const fundClassifications = createLookupHook<FundClassification>(getFundClassifications);
export const useFundClassifications = fundClassifications.useHook;
export const clearFundClassificationsCache = fundClassifications.clear;

const isaFundClassifications = createLookupHook<IsaFundClassification>(getIsaFundClassifications);
export const useIsaFundClassifications = isaFundClassifications.useHook;
export const clearIsaFundClassificationsCache = isaFundClassifications.clear;

const prospectusExposureTypes = createLookupHook<ProspectusExposureType>(getProspectusExposureTypes);
export const useProspectusExposureTypes = prospectusExposureTypes.useHook;
export const clearProspectusExposureTypesCache = prospectusExposureTypes.clear;

const operators = createLookupHook<Operator>(getOperators);
export const useOperators = operators.useHook;
export const clearOperatorsCache = operators.clear;

const trustees = createLookupHook<Trustee>(getTrustees);
export const useTrustees = trustees.useHook;
export const clearTrusteesCache = trustees.clear;

// Companies is tenant-scoped (the api client injects X-Tenant-Id).
const companies = createLookupHook<Company>(getCompanies);
export const useCompanies = companies.useHook;
export const clearCompaniesCache = companies.clear;
